<template>
  <div class="list-footer pt-2 mt-auto">
    <div class="intersection-observer-container">
      <div class="list-footer__count-message" v-if="!loading && total > 0">
        <p class="mt-1 text-color-grey">{{ elementsCountTranslate }}</p>
      </div>

      <div class="list-footer__empty-message" v-else-if="!loading">
        <h4 class="heading-4 mt-1" v-if="short">{{ $t('ui.slots.List.ListFooter.emptyMessage.short') }}</h4>
        <h4 class="heading-4 mt-1" v-else>{{ $t('ui.slots.List.ListFooter.emptyMessage.p1') }}</h4>
        <p class="mt-05" v-if="!short">{{ $t('ui.slots.List.ListFooter.emptyMessage.p2') }}</p>
      </div>

      <div class="list-footer__count-message" v-else><spinner :width="5" :height="5"></spinner></div>
    </div>
  </div>
</template>

<script>
import Spinner from '@/ui/elements/Spinner'

import { pluralize } from 'numeralize-ru'

let timeout

export default {
  name: 'list-footer',

  components: {
    Spinner
  },

  props: {
    total: {
      type: Number,
      default: 0
    },

    loading: {
      type: Boolean,
      default: false
    },

    short: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      observer: null
    }
  },

  computed: {
    elementsCountTranslate () {
      const num = this.total
      return pluralize(
        num,
        this.$i18n.t('ui.slots.List.ListFooter.foundOperations.one', { num }).toString(),
        this.$i18n.t('ui.slots.List.ListFooter.foundOperations.two', { num }).toString(),
        this.$i18n.t('ui.slots.List.ListFooter.foundOperations.five', { num }).toString()
      )
    }
  },

  methods: {
    onElementObserved () {
      clearTimeout(timeout)
      setTimeout(() => {
        this.$emit('appear')
      }, 200)
    }
  },

  created () {
    this.observer = new IntersectionObserver(
      this.onElementObserved,
      {
        root: this.$el,
        threshold: 1.0,
        rootMargin: '40px'
      }
    )
  },

  mounted () {
    this.observer.observe(this.$el)
  },

  beforeDestroy () {
    this.observer.disconnect()
  }
}
</script>

<style lang="scss">
.list-footer {
  &__count-message, &__empty-message {
    /*border-top: 1px $color-space-lighten solid;*/
    text-align: center;
  }
}
</style>
